(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/views/components/row-price-picker.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/views/components/row-price-picker.js');

'use strict';

svs.keno.components.play.views.RowPricePicker = Marionette.View.extend({
  showHeader: true,
  possibleRowPrices: [],
  ui: {
    rowPriceRadio: '.js-row-price-radio',
    rowPriceInformation: '.js-row-price-information'
  },
  triggers: {
    'change @ui.rowPriceRadio': 'changeRowPriceMulti',
    'click @ui.rowPriceInformation': 'clickedInfo'
  },
  className: 'numbergames-footer-section numbergames-row-price-picker js-numbergames-row-price-picker',
  template(data) {
    return svs.keno.components.play.templates.row_price_picker(data);
  },
  templateContext() {
    return {
      possibleRowPrices: this.getOption('possibleRowPrices')
    };
  },
  onChangeRowPriceMulti(view, event) {
    this.model.set('rowPriceMulti', parseInt(event.currentTarget.value, 10));
  },
  onClickedInfo() {
    const title = 'Chans till högre vinster!';
    const text = 'En högre insats per rad gör att du kan vinna större vinster. Kung Keno dubblar priset på raden - men ger alltid vinst om du prickar in Kung Keno-numret!';
    const dialog = new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo: this.getUI('rowPriceInformation'),
      title,
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }
});

 })(window);